import React, { useState, useEffect } from "react";

const WhiteScreen = () => {
  // Sample items to show in the carousel
  const items = [
    {
      id: 1,
      image: "joga.png",
      theme: "Групповые занятия",
      comment: "Bring to the table win survival strategies ensure proactive new domination.",
    },
    {
      id: 2,
      image: "shower.png",
      theme: "Хаммам",
      comment: "1 Membership 5 gyms, with a single membership you can train at all of our branches as your prefer.",
    },
    {
      id: 3,
      image: "massage.png",
      theme: "Массаж и спа",
      comment: "1 Membership 5 gyms, with a single membership you can train at all of our branches as your prefer.",
    },
    {
      id: 4,
      image: "swimming.png",
      theme: "Бассейн",
      comment: "Bring to the table win survival strategies ensure proactive new domination.",
    },
    {
      id: 5,
      image: "hall.png",
      theme: "Тренажерный зал",
      comment: "We provide a fully customized nutrition and training program according to your personal goals.",
    },
    {
      id: 6,
      image: "hall.png",
      theme: "Тренажерный зал",
      comment: "We provide a fully customized nutrition and training program according to your personal goals.",
    },
  ];

  // The current "center" index in items
  const [currentIndex, setCurrentIndex] = useState(0);

  // We'll keep track of the current window width so we can adjust offsets dynamically
  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  const [translateOffset, setTranslateOffset] = useState(300);

  // Update translate offset based on window size
  useEffect(() => {
    function handleResize() {
      const w = window.innerWidth;
      setWindowWidth(w);
      if (w < 640) {
        // small screens
        setTranslateOffset(200);
      } else if (w < 1024) {
        // medium screens
        setTranslateOffset(250);
      } else {
        // large screens
        setTranslateOffset(300);
      }
    }
    // Listen to resize events
    window.addEventListener("resize", handleResize);
    // Initialize offset on mount
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle click on the left or right half of the carousel
  const handleCarouselClick = (e) => {
    // Get the center of the screen
    const screenCenter = windowWidth / 2;

    // If user clicked left half, move left (decrement index); otherwise move right
    if (e.clientX < screenCenter) {
      setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);
    } else {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }
  };

  /**
   * We only want to display 5 cards at a time:
   * positions = -2, -1, 0, 1, 2 relative to the currentIndex
   */
  const visibleOffsets = [-2, -1, 0, 1, 2];
  const totalItems = items.length;

  return (
    <section
      className="relative flex flex-col items-center justify-center bg-white mt-[100px] min-h-screen z-0 px-4"
      onClick={handleCarouselClick}
    >
      {/* Bottom-left background image */}
      <div
        className="pointer-events-none absolute -bottom-1 left-0  
                   transform -scale-y-100 bg-no-repeat bg-contain 
                   w-[200px] h-[200px] sm:w-[300px] sm:h-[300px]"
        style={{ backgroundImage: "url('background-low.png')" }}
      />

      {/* Top-right background image */}
      <div
        className="pointer-events-none absolute -top-[190px] right-0 
                   transform -scale-y-100 bg-no-repeat bg-contain
                   w-[200px] h-[200px] sm:w-[300px] sm:h-[300px]"
        style={{ backgroundImage: "url('background-upper.png')" }}
      />

      {/* Main content container */}
      <div className="relative w-full max-w-full mx-auto">
        {/* Intro text */}
        <div className="flex flex-col items-center justify-center mb-8 text-center">
          <h2 className="text-slate-700 font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-3">
            Ознакомьтесь с нашими услугами
          </h2>
          <p className="text-slate-400 text-base sm:text-lg md:text-xl">
            Раскройте свой потенциал в нашем современном центре, оснащенном
            первоклассным оборудованием и опытными тренерами. Присоединяйтесь к нам в
            путешествии.
          </p>
        </div>

        {/* Carousel Container (made taller to fit bigger cards) */}
        <div className="relative w-full h-[350px] sm:h-[400px] flex items-center justify-center overflow-hidden">
          {visibleOffsets.map((offset) => {
            // The index in the items array for this position
            const itemIndex = (currentIndex + offset + totalItems) % totalItems;
            // The actual item
            const item = items[itemIndex];

            // Horizontal distance based on offset & current screen size
            const translateX = offset * translateOffset;
            // Raise the center card slightly
            const translateY = offset === 0 ? "-10px" : "0px";
            // Slightly enlarge the center card
            const scale = offset === 0 ? 1.1 : 0.9;
            // Ensure the center card is on top
            const zIndex = offset === 0 ? 50 : 40;

            return (
              <div
                key={item.id}
                className="absolute flex flex-col items-center justify-start
                           bg-white rounded-lg shadow-xl text-gray-800
                           transition-all duration-300 ease-in-out
                           w-60 h-64 sm:w-64 sm:h-72 md:w-72 md:h-80 p-4"
                style={{
                  transform: `translateX(${translateX}px) translateY(${translateY}) scale(${scale})`,
                  zIndex,
                }}
              >
                <img
                  className="w-full h-40 sm:h-44 md:h-48 rounded-lg object-cover mb-2"
                  src={item.image}
                  alt="service"
                />
                <h1 className="text-lg sm:text-xl md:text-1xl font-semibold text-slate-700 p-1">
                  {item.theme}
                </h1>
                <p className="line-clamp-3 text-sm sm:text-base text-slate-400 p-1">
                  {item.comment}a
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhiteScreen;
